import "reflect-metadata";
import {inject, injectable} from "inversify";
import {PanelAdmRepository} from "@dropDesk/domain/repositories/panel_adm/panel_adm.repository";
import {BaileysVersionEntity} from "@dropDesk/domain/entities/chat/baileys_version.entity";

@injectable()
export class GetBaileysVersionPanelUseCase {
    private _repository: PanelAdmRepository;

    constructor(@inject(PanelAdmRepository) repository: PanelAdmRepository) {
        this._repository = repository;
    }

    public call(): Promise<BaileysVersionEntity> {
        return this._repository.getBaileysVersion();
    }
}
